var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            size: "small",
            model: _vm.config,
            "label-position": "left",
            "label-width": "180px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "网站开关" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.config["3"],
                    callback: function($$v) {
                      _vm.$set(_vm.config, "3", $$v)
                    },
                    expression: "config['3']"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [_vm._v("关闭")]),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("开启")])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "编号生成规则" } },
            [
              _c(
                "el-input",
                {
                  staticClass: "formItemInput",
                  model: {
                    value: _vm.config.numberPrefix,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "numberPrefix", $$v)
                    },
                    expression: "config.numberPrefix"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("前缀")])],
                2
              ),
              _c(
                "el-input",
                {
                  staticClass: "formItemInput",
                  model: {
                    value: _vm.config.numberNum,
                    callback: function($$v) {
                      _vm.$set(_vm.config, "numberNum", $$v)
                    },
                    expression: "config.numberNum"
                  }
                },
                [_c("template", { slot: "prepend" }, [_vm._v("位数")])],
                2
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手机号数量限制" } },
            [
              _c("el-input", {
                staticClass: "formItemInput",
                model: {
                  value: _vm.config.phoneMaxNum,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "phoneMaxNum", $$v)
                  },
                  expression: "config.phoneMaxNum"
                }
              }),
              _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                _vm._v("一个手机号最多可注册多少会员")
              ])
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "身份证限制个数" } },
            [
              _c("el-input-number", {
                attrs: { min: 1 },
                model: {
                  value: _vm.config.idCardNum,
                  callback: function($$v) {
                    _vm.$set(_vm.config, "idCardNum", $$v)
                  },
                  expression: "config.idCardNum"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { float: "right", "margin-top": "20px" } },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.clickSubmit } },
            [_vm._v("保存")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }